const prefix = "priceSelect";

export const getPriceTranslationKey = (
  isStaggered: boolean,
  index: number,
  pricingLabelOverride: null | string
): string => {
  if (isStaggered) {
    return index === 0 ? `${prefix}.front` : `${prefix}.rear`;
  }
  return pricingLabelOverride ?? `${prefix}.price`;
};
